import { booleanAttribute, Component, computed, input } from '@angular/core';

const NO_DATA_IMAGE = 'assets/images/empty-state/no-data-bird.svg';

const NOT_FOUND_IMAGE = 'assets/images/empty-state/not-found-bird.svg';

@Component({
  selector: 'app-table-empty',
  templateUrl: './table-empty.component.html',
  styleUrl: './table-empty.component.scss',
})
export class TableEmptyComponent {
  message = input.required<string>();

  filtered = input(false, { transform: booleanAttribute });

  notFoundMessage = input('Nothing found. Try changing the search or filters');

  protected image = computed(() => (this.filtered() ? NOT_FOUND_IMAGE : NO_DATA_IMAGE));

  protected text = computed(() => (this.filtered() ? this.notFoundMessage() : this.message()));
}
